import { requestAPI } from '../../../../utils/request';
import {
  fuelTransactionRequest,
  fuelTransactionSuccess,
  fuelTransactionFailure,
  fuelTransactionsRequest,
  fuelTransactionsSuccess,
  fuelTransactionsFailure,
  setDisplayFuelTransactions,
  setTotalFuelTransactions,
} from './actions';
import message from '../../../../utils/message';
import { Dispatch, FuelTransactionData } from '../../../../@types';
import type { APIFilterParams } from '../../ui/filters/initialState';

export const fetchFuelTransactions =
  (
    offset: number,
    limit: number,
    successCallback?: Function,
    filterParams?: APIFilterParams
  ) =>
  (dispatch: Dispatch) => {
    dispatch(fuelTransactionsRequest());
    requestAPI('/fleets/fuelTransactions', {
      limit: limit.toString(),
      offset: offset.toString(),
      ...filterParams,
    })
      .then((data) => {
        dispatch(fuelTransactionsSuccess(data.transactions));
        dispatch(setDisplayFuelTransactions(data.transactions));
        dispatch(setTotalFuelTransactions(data.totalCount));
        if (successCallback && typeof successCallback === 'function') {
          successCallback();
        }
      })
      .catch((err) => {
        dispatch(fuelTransactionsFailure(err));
        message.error(err.message);
      });
  };

export const fetchFuelTransactionById =
  (id: string) => (dispatch: Dispatch) => {
    dispatch(fuelTransactionRequest());

    requestAPI(`/fleets/fuelTransactions/${id}`)
      .then((res) => {
        if (res?.status !== 404) dispatch(fuelTransactionSuccess(res));
      })
      .catch((err) => {
        dispatch(fuelTransactionFailure(err));
        message.error(err.message);
      });
  };

export const fetchFuelTransactionByRydOrderId = (
  rydOrderId: string
): Promise<FuelTransactionData | undefined> =>
  requestAPI('/fleets/fuelTransactions', {
    externalId: rydOrderId,
    type: 'ryd',
    offset: '0',
    limit: '1',
  })
    .then(({ transactions }) =>
      (transactions as FuelTransactionData[] | undefined)?.find(
        (t) => t.uniqueId === rydOrderId
      )
    )
    .catch(() => undefined);
